const routes = [
  {
    path: "/manage-account",
    name: "Account",
    component: () => import("@/components/profile/Profile"),
    meta: {
      title: "Lima | Manage Profile",
      requiresAuth: true,
      isAdmin: true,
    },
  },
];
export default routes;
